module.exports = "/_next/static/images/features-budget-0c9f1d4dba15f3fe9d777f996170ef76.png";